import { useEffect, useRef } from "react";
import { onMessage } from "firebase/messaging";
import { getMessagingInstance } from "../firebase";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";

import { notificationAudio } from "../audio";

export function useFirebaseMessaging() {
  const dispatch = useDispatch();
  const { unreadCount } = useSelector((state) => state.notification);

  useEffect(() => {
    const enforceTitle = () => {
      // Remove existing count prefix if any
      const titleWithoutCount = document.title.replace(/^\(\d+\)\s/, "");

      if (unreadCount > 0) {
        if (!document.title.startsWith(`(${unreadCount}) `)) {
          document.title = `(${unreadCount}) ${titleWithoutCount}`;
        }
      } else {
        document.title = titleWithoutCount;
      }
    };

    // Apply immediately
    enforceTitle();

    // Re-apply on visibility change
    document.addEventListener("visibilitychange", enforceTitle);

    return () => {
      document.removeEventListener("visibilitychange", enforceTitle);
    };
  }, [unreadCount]);

  useEffect(() => {
    let unsubscribe;

    const setupListener = async () => {
      const messaging = await getMessagingInstance();
      if (messaging) {
        unsubscribe = onMessage(messaging, (payload) => {
          console.log("Foreground message received:", payload);
          dispatch(
            showToast({
              message: `${payload.notification?.title ? payload.notification.title + ": " : ""}${payload.notification?.body || ""
                }`,
              type: "success",
            })
          );

          try {
            notificationAudio.currentTime = 0;
            notificationAudio.play().catch((error) => console.error("Error playing sound:", error));
          } catch (error) {
            console.error("Audio playback failed", error);
          }
          if (Notification.permission === "granted") {
            new Notification(payload.notification.title, {
              body: payload.notification.body,
              // icon: payload.data.icon,
            });
          }
        });
      }
    };

    setupListener();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);
}
